/* eslint-disable @typescript-eslint/no-explicit-any */

export const readAttribute = (
  dataCloudInteractions: any,
  selector: string,
  attribute: string,
) => {
  return dataCloudInteractions.cashDom(selector).attr(attribute);
};

export const parseNumericAttribute = (
  raw: string | undefined,
): number | undefined => {
  if (raw === undefined || raw === null || raw === "") {
    return undefined;
  }
  const value = Number(raw);
  return Number.isFinite(value) ? value : undefined;
};

interface BreadcrumbLike {
  urlSlug?: string | null;
}

export interface CategoryPayload {
  id: string;
  primaryCategory?: string;
  subCategory?: string;
}

export const getValidBreadcrumbs = <T>(
  breadcrumbs: (T | null | undefined)[] | null | undefined,
): T[] => {
  if (!breadcrumbs?.length) {
    return [];
  }

  return breadcrumbs.filter(Boolean) as T[];
};

export const buildCategoryPayload = (categories: string[]): CategoryPayload => {
  const normalizedCategories = categories
    .map((category) => category.toUpperCase())
    .filter(Boolean);

  return {
    id: normalizedCategories.join("|"),
    primaryCategory: normalizedCategories[0],
    subCategory: normalizedCategories.slice(1).join("|"),
  };
};

export const buildCategoryPayloadFromBreadcrumbs = (
  breadcrumbs: BreadcrumbLike[],
): CategoryPayload => {
  const categories = breadcrumbs
    .map((breadcrumb) => {
      const slugParts = breadcrumb.urlSlug ? breadcrumb.urlSlug.split("/") : [];
      return slugParts.at(-1) || "";
    })
    .filter(Boolean);

  return buildCategoryPayload(categories);
};

export const getCategoryPathFromPagePath = (pathSegments: string[]): string => {
  const categoryPath =
    pathSegments[0] === "c" ? pathSegments.slice(1) : pathSegments;

  return categoryPath.join("|").toUpperCase();
};

export const getCategoryIdFromPagePath = (pathSegments: string[]): string => {
  return (pathSegments.at(-1) || "").toUpperCase();
};

interface BreadcrumbJson {
  title?: string | null;
  urlSlug?: string | null;
  position?: number | null;
}

export const getCategoryPathFromBreadcrumbsJson = (raw: string): string => {
  if (!raw) {
    return "";
  }
  let parsed: BreadcrumbJson[];
  try {
    parsed = JSON.parse(raw);
  } catch {
    return "";
  }
  if (!Array.isArray(parsed) || parsed.length === 0) {
    return "";
  }
  const anyHasPosition = parsed.some((item) => typeof item?.position === "number");
  const ordered = anyHasPosition
    ? [...parsed].sort((a, b) => (a?.position ?? 0) - (b?.position ?? 0))
    : parsed;
  return ordered
    .map((item) => {
      const lastSlugSegment = item?.urlSlug?.split("/").at(-1);
      return lastSlugSegment || item?.title || "";
    })
    .filter(Boolean)
    .join("|")
    .toUpperCase();
};
